(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/shared-components/login-iframe.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/shared-components/login-iframe.js');

'use strict';

const {
  logger
} = svs.playerLoginReact;
const LoginIframe = () => {
  const {
    isTestEnvironment
  } = ReactRedux.useSelector(state => state.playerloginreact);
  const iamIframeUrl = ReactRedux.useSelector(state => state.playerloginreact.iamIframeUrl);
  logger.info('IAM Rendering LoginIframe component, isTestEnvironment:', isTestEnvironment, 'iamIframeUrl:', iamIframeUrl);
  return React.createElement("iframe", {
    allow: "local-network-access",
    className: "iamlogin-iframe".concat(isTestEnvironment ? ' iamlogin-iframe-test-panel' : ''),
    id: "iamlogin-iframe",
    sandbox: "allow-same-origin allow-scripts allow-forms allow-modals allow-popups allow-top-navigation-by-user-activation",
    src: iamIframeUrl
  });
};
svs.playerLoginReact.sharedComponents.LoginIframe = LoginIframe;

 })(window);